import { Component, input } from '@angular/core';
import { RouterLink, RouterModule } from '@angular/router';
import { IonIcon, IonItem, IonLabel, IonList } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { chatbubblesOutline, chevronForwardOutline, sparklesOutline, helpCircleOutline } from 'ionicons/icons';
import { Chat } from 'src/app/features/stories/types/Chat';
import { aiChatTitleKey } from 'src/app/features/stories/utils/aiChatTitle';
import { TRANSLATE_IMPORTS } from 'src/app/features/i18n/translate-imports';

@Component({
  selector: 're-chats-list',
  imports: [
    IonIcon,
    IonItem,
    IonLabel,
    IonList,
    RouterLink,
    RouterModule,
    ...TRANSLATE_IMPORTS,
  ],
  templateUrl: './chats-list.component.html',
  styleUrls: ['./chats-list.component.scss'],
})
export class ChatsListComponent {
  chats = input.required<Chat[]>();
  compact = input(false);

  constructor() {
    addIcons({ chatbubblesOutline, chevronForwardOutline, sparklesOutline, helpCircleOutline });
  }

  chatIcon(chat: Chat): string {
    if (chat.kind === 'lore') return 'help-circle-outline';
    if (chat.kind === 'story') return 'sparkles-outline';
    return 'chatbubbles-outline';
  }

  chatTitleKey(chat: Chat): string | null {
    return aiChatTitleKey(chat.kind);
  }

  chatSubtitle(chat: Chat): string {
    if (chat.kind === 'lore') return 'stories.chats.loreDesc';
    if (chat.kind === 'story') return 'stories.chats.storyDesc';
    return 'stories.home.roomParticipants';
  }

  chatSubtitleParams(chat: Chat): { count?: number } {
    if (chat.kind === 'lore' || chat.kind === 'story') return {};
    return { count: chat.users?.length ?? 0 };
  }
}
